(function () {
  const DEBUG = false;
  if (DEBUG) console.debug("sticky-add-to-cart-mobile");

  const productInfoWrapper = document.getElementById("product__info-wrapper");
  if (!productInfoWrapper) throw "'productInfoWrapper' not defined";

  const addToCartButton = productInfoWrapper.querySelector("#addToCartForm");
  if (!addToCartButton) throw "'addToCartButton' not defined";

  const sbmtBtn = productInfoWrapper.querySelector("#product-form-submit-btn");
  if (!sbmtBtn) throw "'sbmtBtn' not defined";

  const variantButton = document.querySelector(
    ".product__info-container #variant-selector-form"
  );
  if (!variantButton) throw "'variantButton' not defined";

  const titleBlock = document.getElementById("product-title-block");
  if (!titleBlock) throw "'titleBlock' not defined";

  const titleFont = document.getElementById("product-title");
  if (!titleFont) throw "'titleFont' not defined";

  // const priceFont = document.getElementById("price-regular-fonts");
  // const cookieBtn = document.getElementById("ot-sdk-btn-floating");
  const klaviyoBtn = document.getElementById("klaviyo-btn");
  if (!klaviyoBtn) throw "'klaviyoBtn' not defined";

  const errorMsg = document.getElementById("error-msg-pdp");
  if (!errorMsg) throw "'errorMsg' not defined";

  if (false && DEBUG)
    console.debug({
      productInfoWrapper,
      addToCartButton,
      sbmtBtn,
      variantButton,
      titleBlock,
      titleFont,
      klaviyoBtn,
      errorMsg,
    });

  function stickyButton() {
    if (DEBUG) console.debug("stickyButton");

    const pageWidth = document.documentElement.clientWidth || window.innerWidth;
    if (750 < pageWidth) return; // Not mobile, nothing to do
    if (false && DEBUG) console.debug("Is mobile, proceed");

    const chatButton = document.querySelector("div.helpButton");
    const offsetHeight = productInfoWrapper.offsetHeight;

    const buttonDistanceFromTop = addToCartButton.offsetTop;
    const currentDistanceFromTop = window.scrollY; // px from page start of current view
    const didIPassedTheButton = buttonDistanceFromTop <= currentDistanceFromTop;
    const haveIReachedTheBottomOfThePage =
      document.body.offsetHeight <= currentDistanceFromTop + window.innerHeight;

    if (false && DEBUG)
      console.debug({
        offsetHeight,
        buttonDistanceFromTop,
        currentDistanceFromTop,
        didIPassedTheButton,
        haveIReachedTheBottomOfThePage,
      });

    if (didIPassedTheButton && !haveIReachedTheBottomOfThePage) {
      errorMsg.classList.add("error-msg-sticky-mobile");
      addToCartButton.classList.add("sticky-buttonAddToCart-mobile");
      variantButton.classList.add("sticky-variantSelector-mobile");
      titleBlock.classList.add("sticky-titleBlock-mobile");
      titleFont.classList.add("productTitleFontMobile-sticky");
      //priceFont.classList.add("productPriceFontMobile-sticky");
      sbmtBtn.classList.add("sticky-sbmtBtn-mobile");
      klaviyoBtn.classList.add("sticky-sbmtBtn-mobile");
      //document.getElementById("ot-sdk-btn-floating").style.bottom = "140px";
      //document.getElementById("szb-container").style.display = "none";
      if (chatButton)
        chatButton.style.bottom = `calc(100px + ${titleBlock.offsetHeight}px)`;
    } else {
      errorMsg.classList.remove("error-msg-sticky-mobile");
      addToCartButton.classList.remove("sticky-buttonAddToCart-mobile");
      variantButton.classList.remove("sticky-variantSelector-mobile");
      titleBlock.classList.remove("sticky-titleBlock-mobile");
      titleFont.classList.remove("productTitleFontMobile-sticky");
      //priceFont.classList.remove("productPriceFontMobile-sticky");
      sbmtBtn.classList.remove("sticky-sbmtBtn-mobile");
      klaviyoBtn.classList.remove("sticky-sbmtBtn-mobile");
      //document.getElementById("ot-sdk-btn-floating").style.bottom = "10px";

      addToCartButton.classList.add("remove-sticky");
      variantButton.classList.add("remove-sticky");
      titleBlock.classList.add("remove-sticky");
      sbmtBtn.classList.add("remove-sticky");
      klaviyoBtn.classList.add("remove-sticky");
      if (chatButton) chatButton.style.bottom = "0px";
      if (haveIReachedTheBottomOfThePage)
        productInfoWrapper.style.height = `${offsetHeight}px`;
      else productInfoWrapper.style.height = "auto";
    }
  }

  document.addEventListener("scroll", stickyButton);

  const stickyMenuElements = [addToCartButton, variantButton, titleBlock];
  const productRecommendationSections = document.querySelectorAll(
    '[class*="product-recommendations-section-"]'
  );

  let isHidden = false;

  function hideStickyMenuElements() {
    if (isHidden) return;
    if (DEBUG) console.debug("hideStickyMenuElements");
    isHidden = true;
    for (const observedElement of stickyMenuElements)
      observedElement.classList.add("hidden");
  }

  function showStickyMenuElements() {
    if (!isHidden) return;
    if (DEBUG) console.debug("showStickyMenuElements");
    isHidden = false;
    for (const observedElement of stickyMenuElements)
      observedElement.classList.remove("hidden");
  }

  if (!productRecommendationSections)
    throw "'productRecommendationSections' not defined";
  if (!stickyMenuElements) throw "'stickyMenuElements' not defined";

  let timeoutId;
  let previousScrollY;

  const bottomOffsetHeight = 140; // calculated height in px of sticky "add to cart" form
  const observer = new IntersectionObserver(
    (entries) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        if (window.scrollY === previousScrollY) return;
        previousScrollY = window.scrollY;

        for (const entry of entries) {
          const isInViewport = entry.isIntersecting;
          if (!isInViewport) {
            showStickyMenuElements();
            continue;
          }

          const spaceFromBottom =
            window.innerHeight - entry.boundingClientRect.bottom;
          if (bottomOffsetHeight >= spaceFromBottom) hideStickyMenuElements();
          else showStickyMenuElements();
        }
      }, 250);
    },
    {
      threshold: [0, 0.05, 0.1, 0.25, 0.5, 0.75, 0.9, 0.95, 1],
    }
  );
  for (const productRecommendationSection of productRecommendationSections)
    observer.observe(productRecommendationSection);
})();
